(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('accordion-item')) {
    class AccordionItem extends HTMLElement {
      constructor() {
        super();

        const anchorID = window.location.hash?.replace('#', '');
        if (this.firstElementChild.id === anchorID) {
          Array.from(this.parentElement.children).forEach(child => {
            child.firstElementChild.removeAttribute('open');
          });

          document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
              this.firstElementChild.querySelector('.accordion__title.summary').click();
            });
          });
        }
      }
    }

    customElements.define('accordion-item', AccordionItem);
  }

  document.addEventListener("DOMContentLoaded", function(event) {

    $('.accordion__title.summary').click(function(){ 
      if($(this).parent().attr('open')) {  
        $(this).parent().find('.accordion__content').hide();
        $(this).attr('aria-expanded', false) 
        $(this).parent().removeAttr('open')
      } else {
        $(this).attr('aria-expanded', true) 
        $(this).parent().attr('open', '');
        $(this).parent().find('.accordion__content').show();
      }
    })

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hand-me-doen-collection-product-grid"]) return;
  try {
    
  if (window.previewMode) {
    const runQueries = settings => {
      if (runCollectionQueries) {
        return runCollectionQueries(settings)
      }

      setTimeout(() => {
        runQueries(settings)
      }, 500)
    }

    document.addEventListener('DOMContentLoaded', runQueries)
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      window.endlessScroll = new ShopifyInfiniteScroll({
        container: '#product-grid',
        pagination: '#product-pagination',
        offset: 2000,
        buttonId: '#disable-infinite-scroll'
      })
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (window.previewMode) {
    const runQueries = settings => {
      if (runCollectionQueries) {
        return runCollectionQueries(settings)
      }

      setTimeout(() => {
        runQueries(settings)
      }, 500)
    }

    document.addEventListener('DOMContentLoaded', runQueries)
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      window.endlessScroll = new ShopifyInfiniteScroll({
        container: '#product-grid',
        pagination: '#product-pagination',
        offset: 2000,
        buttonId: '#disable-infinite-scroll'
      })
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-journal"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      window.endlessScroll = new ShopifyInfiniteScroll({
        container: '#journal__grid',
        pagination: '#journal-pagination',
        offset: 1000,
        buttonId: '#disable-infinite-scroll'
      })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (window.previewMode) {
    const runQueries = settings => {
      if (runCollectionQueries) {
        return runCollectionQueries(settings)
      }

      setTimeout(() => {
        runQueries(settings)
      }, 500)
    }

    document.addEventListener('DOMContentLoaded', runQueries)
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      window.endlessScroll = new ShopifyInfiniteScroll({
        container: '#product-grid',
        pagination: '#product-pagination',
        offset: 2000,
        buttonId: '#disable-infinite-scroll'
      })
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-grid-collection-product-grid"]) return;
  try {
    
  if (window.previewMode) {
    const runQueries = settings => {
      if (runCollectionQueries) {
        return runCollectionQueries(settings)
      }

      setTimeout(() => {
        runQueries(settings)
      }, 500)
    }

    document.addEventListener('DOMContentLoaded', runQueries)
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      window.endlessScroll = new ShopifyInfiniteScroll({
        container: '#product-grid',
        pagination: '#product-pagination',
        offset: 2000,
        buttonId: '#disable-infinite-scroll'
      })
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teaser-collection-product-grid"]) return;
  try {
    
  if (window.previewMode) {
    const runQueries = settings => {
      if (runCollectionQueries) {
        return runCollectionQueries(settings)
      }

      setTimeout(() => {
        runQueries(settings)
      }, 500)
    }

    document.addEventListener('DOMContentLoaded', runQueries)
  } else {
    
  }

  } catch(e) { console.error(e); }
})();
})();
